import { extendObservable } from 'mobx'
import { searchApi } from '@atheneum/api'
import debounce from 'lodash/debounce'

const paths = {
  expert: 'expert',
  project: 'project',
  parent_account: 'client-search/parent-account',
  account: 'client-search/account',
  office: 'client-search/office',
  contract: 'contract',
  client: 'client-contact'
}

function getItemType ({ indexType }) {
  switch (indexType) {
    case 'parent_account':
      return 'Parent Account'
    default:
      return indexType
  }
}

class SearchStore {
  constructor () {
    extendObservable(this, {
      query: '',
      results: [],
      targetIndex: 0
    })
  }

  onChange (val) {
    this.query = val
    this.search()
  }

  targetUp () {
    if (this.targetIndex === 0) return
    this.targetIndex -= 1
  }

  targetDown () {
    if (this.targetIndex === this.results.length - 1) return
    this.targetIndex += 1
  }

  clean () {
    this.results = []
    this.query = ''
  }

  searchExtern = async query => {
    const data = await searchApi.search(query)
    return data.map(i => {
      i.itemType = getItemType(i)
      i.link = `/${paths[i.indexType]}/${i.id}`
      return i
    })
  }

  search = debounce(async () => {
    const data = await searchApi.search(this.query)
    this.results = data.map(i => {
      i.itemType = getItemType(i)
      i.link = `/${i.indexType}/${i.id}`
      return i
    })
    this.targetIndex = 0
  }, 250)
}

export default SearchStore
